export const environment = {
  apiUrl: 'https://dev-ententes.cinego.net/v2',
  homeDir: 'https://dev-ententes.cinego.net/home',
  production: false,
};
